module.exports = __webpack_public_path__ + "static/media/img1.d774f942.jpg";